function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-5.478 2A6.47 6.47 0 009 15.5c0 1.644.61 3.145 1.617 4.29-.802.141-1.675.21-2.617.21-2.89 0-5.128-.656-6.691-2a3.75 3.75 0 01-1.306-2.843v-.907A2.25 2.25 0 012.253 12h7.77zm3.07.966l-.068.058-.058.07a.5.5 0 000 .568l.058.069 1.77 1.77-1.768 1.766-.058.07a.5.5 0 000 .568l.058.07.07.057a.5.5 0 00.568 0l.07-.058 1.766-1.767 1.77 1.77.069.058a.5.5 0 00.568 0l.07-.058.057-.07a.5.5 0 000-.568l-.058-.07-1.769-1.768 1.772-1.77.058-.07a.5.5 0 000-.568l-.058-.069-.07-.058a.5.5 0 00-.568 0l-.069.058-1.772 1.77-1.77-1.77-.069-.058a.5.5 0 00-.492-.043l-.076.043zM8 .004a5 5 0 110 10 5 5 0 010-10z",
  fill: "#8F90A6"
});

function SvgRemoveUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRemoveUser;